import { NgModule } from '@angular/core';
import { MAT_LEGACY_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/legacy-form-field';
import { CuttingButtFormService } from '../../services/cutting-butt-form.service';
import { CountertopSettingsDataService } from './countertop-settings-data.service';
import { CountertopSettingsComponent } from './countertop-settings.component';
import { CountertopsAvailableComponentsService } from './countertops-available-components.service';
import { FastenersComponent } from './fasteners/fasteners.component';
import { ItemCardComponent } from './item-card/item-card.component';
import { MaterialsComponent } from './materials/materials.component';
import { SizesComponent } from './sizes/sizes.component';
import { SlotsComponent } from './slots/slots.component';

@NgModule({
  imports: [
    CountertopSettingsComponent,
    ItemCardComponent,
    MaterialsComponent,
    FastenersComponent,
    SlotsComponent,
    SizesComponent,
  ],
  providers: [
    CountertopSettingsDataService,
    CuttingButtFormService,
    CountertopsAvailableComponentsService,
    { provide: MAT_LEGACY_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
  ],
  exports: [CountertopSettingsComponent],
})
export class CountertopSettingsModule {}
